/**
 * Created by sagil on 07/12/2016.
 */
import { Injectable } from "@angular/core";
import { APIProxy } from "../../../../common/http/services/api.proxy";
import { HttpObservable } from "../../../../common/http/services/http.wrapper";
import { IMetadataGroup } from "../../../../dev/components/elad.forms2/interfaces/metadata/imetadata.group";

@Injectable({ providedIn: 'root' })
export class MetadataProxy{
	constructor(private http:APIProxy){
	}

	public getPatientMetadata() : HttpObservable<{patient:IMetadataGroup}>{
		return this.http.getAnon("ClinicalMetaData","GetPatientMetadata");
	}
}
